import React, { useEffect } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { RealEstateDataPageComponentData } from 'types'
import Image from '@components/Image'
import { Col, Container, Row } from 'react-bootstrap'
import { ElementHTML } from '@helpers/helper.rendering'

const AboutUs_6 = (props: RealEstateDataPageComponentData) => {
  const {
    items,
    image_gatsby,
    titleElement,
    paragraphElement,
    titleColor,
    titleHexa,
    backgroundHexa,
    backgroundColor,
    opacityValue,
  } = props

  useEffect(() => {
    AOS.init({ duration: 2000 })
  }, [])

  return (
    <section className="about-compromiso position-relative a">
      <div className="first-item">
        <Container
          className="position-relative"
          fluid
        >
          <Row className="items">
            <Col xs={12}>
              <ElementHTML
                children={items![0].title || ''}
                elementType={titleElement || 'h1'}
                className={'title ' + titleColor}
                style={{ color: titleHexa }}
              />
              <ElementHTML
                children={items![0].paragraph || ''}
                elementType={paragraphElement || 'p'}
                className={'paragraph ' + titleColor + ' ' + (paragraphElement || 'custom')}
                style={{ color: titleHexa }}
              />
            </Col>
          </Row>
        </Container>
      </div>
      <div className="second-item">
        <div
          className={'opacity-background ' + backgroundColor}
          style={{
            backgroundColor: backgroundHexa || '6b6b6b6',
            opacity:
              opacityValue && opacityValue !== '0'
                ? Number(opacityValue) !== 100
                  ? `0.${Number(opacityValue)}`
                  : 1
                : 0.6,
          }}
        ></div>
        {image_gatsby && (
          <div
            className="image-parallax img"
            style={{
              //@ts-ignore
              backgroundImage: `url(${image_gatsby!.url?.childImageSharp?.gatsbyImageData.images
                .fallback.src})`,
            }}
          ></div>
        )}
        <Container
          className="position-relative"
          fluid
        >
          <Row className="items">
            <Col
              lg={{ span: 6, offset: 6 }}
              xs={{ span: 12 }}
            >
              <ElementHTML
                children={items![1].title || ''}
                elementType={titleElement || 'h1'}
                className={'title'}
              />
              <ElementHTML
                children={items![1].paragraph || ''}
                elementType={paragraphElement || 'p'}
                className={'paragraph ' + (paragraphElement || 'custom')}
              />
            </Col>
          </Row>
        </Container>
      </div>

      <div className="third-item">
        <Container fluid>
          <Row className="items">
            <Col
              xs={12}
              // data-aos="fade-left"
            >
              <ElementHTML
                children={items![2].title || ''}
                elementType={titleElement || 'h1'}
                className={'title ' + titleColor}
                style={{ color: titleHexa }}
              />
              <ElementHTML
                children={items![2].paragraph || ''}
                elementType={paragraphElement || 'p'}
                className={'paragraph ' + titleColor + ' ' + (paragraphElement || 'custom')}
                style={{ color: titleHexa }}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  )
}

export default AboutUs_6
